const optimaRouterPath = `/optima`;
const optimaInputRouterPath = `/optima/input`;
const optimaOutputRouterPath = `/optima/output`;
const optimaAllDepotRouterPath = `/optima/input/allDepot`;

// split screen route path
const optimaInputSplitRouterPath = `/optima/input/split`;
const optimaInputCreateDNPath = `/optima/input/createDN`;

const optimaAllDepotRoutes = [
  {
    path: optimaAllDepotRouterPath,
    name: 'Optima All Depot',
    component: () => import(/* webpackChunkName: "Optima" */ '@/components/modules/optima/input/list/AllDepot'),
    meta: {
      title: 'Optima All Depot',
    },
    props: true,
  },
];

const optimaInputRoutes = [
  {
    path: optimaInputRouterPath,
    name: 'Optima Input',
    component: () => import(/* webpackChunkName: "Optima" */ '@/components/modules/optima/input/list/index'),
    meta: {
      title: 'Optima Input',
    },
    props: true,
  },
  {
    path: optimaInputSplitRouterPath,
    name: 'Optima Input Split',
    component: () => import(/* webpackChunkName: "Optima" */ '@/components/modules/optima/input/split/index'),
    meta: {
      title: 'Optima Input Split',
    },
    props: true,
  },
  {
    path: optimaInputCreateDNPath,
    name: 'Optima Input Create DN',
    component: () => import(/* webpackChunkName: "Optima" */ '@/components/modules/optima/input/optima-create-delivery-number/OptimaCreateDn'),
    meta: {
      title: 'Optima Input Create DN',
    },
  },
  {
    path: '/optima/indent/create',
    name: 'OptimaIndent',
    component: () => import(/* webpackChunkName: "Optima" */ '@/modules-v2/indent/views/create-update/optimaIndent'),
    meta: {
      title: 'Optima Indent',
    },
    props: true,
  },
];

const optimaOutputRoutes = [
  {
    path: optimaOutputRouterPath,
    name: 'Optima',
    component: () => import(/* webpackChunkName: "Optima" */ '@/components/modules/optima/output/list/Optimav2'),
    meta: {
      title: 'Optima',
    },
    props: true,
  }, {
    path: `${optimaOutputRouterPath}/summary`,
    name: 'Summary',
    component: () => import(/* webpackChunkName: "Summary" */ '@/components/modules/optima/output/summary/index'),
  }, {
    path: `${optimaOutputRouterPath}/details`,
    name: 'Details',
    component: () => import(/* webpackChunkName: "Details" */ '@/components/modules/optima/output/list/details/Details'),
  }, {
    path: `${optimaOutputRouterPath}/:indentId/materials`,
    name: 'OptimaMaterials',
    component: () => import(/* webpackChunkName: "OptimaMaterials" */ '@/components/modules/optima/output/materialView'),
  }, {
    path: `${optimaOutputRouterPath}/:indentId/split`,
    name: 'OptimaSplit',
    component: () => import(/* webpackChunkName: "OptimaSplit" */ '@/components/modules/optima/output/list/optimaSplit'),
  }, {
    path: `${optimaOutputRouterPath}/combine`,
    name: 'OptimaCombine',
    component: () => import(/* webpackChunkName: "OptimaCombine" */ '@/components/modules/optima/output/list/optimaCombine'),
  }, {
    path: `${optimaOutputRouterPath}/edit`,
    name: 'CompareOrders',
    component: () => import(/* webpackChunkName: "CompareOrders" */ '@/components/modules/optima/output/compare/index'),
    meta: {
      title: 'Edit Indents',
    },
  }, {
    path: '/visualize',
    name: 'Visualize',
    component: () => import(/* webpackChunkName: "Visualize" */ '@/components/modules/Visualize/index'),
    meta: {
      title: 'Visualize',
    },
  }, {
    path: `${optimaOutputRouterPath}/split`,
    name: 'OptimaSplit',
    component: () => import(/* webpackChunkName: "OptimaSplit" */ '@/components/modules/optima/output/list/optimaSplit'),
    meta: {
      title: 'Optima Split',
      requiresAuth: true,
    },
  }, {
    path: `${optimaOutputRouterPath}/:indentId/editOrder`,
    name: 'EditOrder',
    component: () => import(/* webpackChunkName: "OptimaEdit" */ '@/components/modules/optima/output/list/EditOrder'),
    meta: {
      title: 'Optima Edit',
      requiresAuth: true,
    },
  }
];

const optimaSettingsRoutes = [
  {
    path: `${optimaRouterPath}/constraints`,
    name: 'OptimaSettings',
    component: () => import(/* webpackChunkName: "OptimaSettings" */ '@/components/modules/optima/settings/index'),
    meta: {
      title: 'Optima Constraints',
    },
  }, {
    path: `${optimaRouterPath}/cs`,
    name: 'CustomerSettings',
    component: () => import(/* webpackChunkName: "CustomerSettings" */ '@/components/modules/optima/settings/index'),
    meta: {
      title: 'Optima Settings',
    },
  },
];

const optima = [
  ...optimaInputRoutes,
  ...optimaOutputRoutes,
  ...optimaSettingsRoutes,
  ...optimaAllDepotRoutes,
];
export default optima;
